import { DropdownOption, FormFieldState, Holiday, makeDefaultMeetingState } from '@studio/atomic-ui'
import { ProductSource } from '../../types/product'

export const setDeskState = (from: string, to: string, desks: string, isSameDay: boolean) => {
  const deskOption: { value: DropdownOption } = {
    value: { label: parseInt(desks) === 1 ? '1 day pass' : `${desks} day passes`, value: desks },
  }

  if (isSameDay) {
    return {
      date: { value: { from: new Date(from) }, open: false },
      desks: deskOption,
    }
  } else
    return {
      date: { value: { from: new Date(from), to: new Date(to) }, open: false },
      desks: deskOption,
    }
}

export const setOfficeState = (from: string, to: string, isSameDay: boolean) => {
  if (isSameDay) {
    return {
      date: { value: { from: new Date(from) }, pristine: true, open: false },
    }
  } else
    return {
      date: { value: { from: new Date(from), to: new Date(to) }, pristine: true, open: false },
    }
}

export const setMeetingState = (
  source: ProductSource,
  from?: string,
  to?: string,
  duration?: string,
  labelDuration?: string,
  startTime?: string,
  isSameDay = false,
  holidays?: Holiday
): FormFieldState => {
  // Unsupported use case, impossible to occur in user interactions
  const initialState = makeDefaultMeetingState(holidays, duration, labelDuration)

  if (!from) return initialState

  return {
    ...initialState,
    date: {
      value: { from: new Date(from), ...(to && !isSameDay ? { to: new Date(to) } : {}) },
      pristine: true,
      open: false,
    },
    ...(duration && labelDuration && labelDuration
      ? {
          duration: {
            value: {
              label: labelDuration,
              value: duration,
            },
          },
        }
      : {}),
    ...(startTime
      ? {
          startTime: {
            value: {
              label: '',
              timeslot: startTime,
              ...(!isSameDay ? { loading: true } : {}),
            },
          },
        }
      : {}),
    needsAdditionalServices: { value: false },
    additionalServices: { value: '' },
  }
}
